<template>
  <div id="user-group">
    <div height="55px" class="header">
      <el-button-group>
        <el-button icon="el-icon-refresh" @click="pageRefresh" size="small">刷新</el-button>
      </el-button-group>

      <el-input v-model="key" size="small" style="margin-left: 20px; width: 200px;" placeholder="搜索"></el-input>
    </div>
    <div class="main-content">
      <el-table :data="adminList">
        <el-table-column prop="date" label="头像" width="120">
          <template slot-scope="scope">
            <div class="headimg">
              <img :src="scope.row.headimg" v-if="scope.row.headimg">
              <img src="../../assets/default_img.png" v-else>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
            <el-tag v-if="scope.row.gender==='男'" size="mini">{{scope.row.gender}}</el-tag>
            <el-tag v-else type="success" size="mini">{{scope.row.gender}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱">
        </el-table-column>
        <el-table-column prop="phone" label="手机号">
        </el-table-column>
        <el-table-column label="机构">
          <template slot-scope="scope">
            <template v-if="scope.row.partners.length > 3">
              <span style="color: red">(共授权{{scope.row.partners.length}}家机构)</span>
            </template>
            <template v-else>
              <span v-for="(item,index) in scope.row.partners" :key="index">{{item.title}}<br /></span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editItem(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="编辑管理员" :visible.sync="dialogVisible" width="800px">
        <el-form class="form" :model="form" :rules="rules" ref="form" label-width="80px" size="small">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="管理员姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="form.gender">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="机构" prop="partner_ids">
            <el-select v-model="form.partner_ids" multiple placeholder="机构" clearable style="width: 660px">
              <el-option v-for="item in partner" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="邮箱" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="手机号" clearable></el-input>
          </el-form-item>
          <el-form-item label="工号" prop="number">
            <el-input v-model="form.number" placeholder="选填" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">保存更改</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  export default {
    name: 'PlatformAdmin',
    data() {
      let validateEamil = (rule, value, callback) => {
        let reg = new RegExp('^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(.[a-zA-Z0-9-]+)*.[a-zA-Z0-9]{2,6}$')
        if (value === '') {
          callback(new Error('请输入邮箱!'))
        } else if (!reg.test(value)) {
          callback(new Error('邮箱格式错误!'))
        } else {
          callback()
        }
      }

      let validatePhone = (rule, value, callback) => {
        let reg = new RegExp('^((1[0-9]))\\d{9}$')
        if (value === '') {
          callback(new Error('请输入手机号!'))
        } else if (!reg.test(value)) {
          callback(new Error('手机号格式错误!'))
        } else {
          callback()
        }
      }
      return {
        partner: [],
        per_page: 100,
        page: 1,
        total: 0,
        adminList: [],
        dialogVisible: false,
        key: '',
        form: {
          partner_ids: [],
          name: '',
          gender: '',
          email: '',
          phone: '',
          number: ''
        },
        rules: {
          name: [{
            required: true,
            message: '请输入管理员姓名',
            trigger: 'blur'
          }],
          email: [{
            required: true,
            validator: validateEamil,
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            validator: validatePhone,
            trigger: 'blur'
          }]
        },
        current: {}
      }
    },
    mounted() {
      this.getTenantList()
      this.activeGroupList()
    },
    watch: {
      key () {
        this.page = 1
        this.activeGroupList()
      }
    },
    methods: {
      pageRefresh() {
        this.activeGroupList()
      },
      getTenantList() {
        request({
          url: 'partners',
          method: 'get'
        }).then(res => {
          this.partner = res.data.list
        })
      },
      activeGroupList() {
        let sendData = {
          page: this.page,
          per_page: this.per_page,
          key: this.key
        }
        request({
          url: 'partner-admins',
          method: 'get',
          params: sendData
        }).then(res => {
          let list = res.data.list
          list.forEach(item => {
            let info = item.info
            delete item.info
            item = Object.assign(item, info)
          })
          this.adminList = list
          this.total = res.data.item_total
        })
      },
      currentPageChange(e) {
        this.page = e
        this.activeGroupList()
      },
      editItem(row) {
        this.current = JSON.parse(JSON.stringify(row))
        this.form = {
          partner_ids: this.current.partner_ids,
          name: this.current.name,
          gender: this.current.gender,
          email: this.current.email,
          phone: this.current.phone,
          number: this.current.number
        }
        this.dialogVisible = true
      },
      deleteItem(row) {
        this.$confirm('删除该机构管理员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          request({
            url: 'partner-admins/' + row.uuid,
            method: 'delete'
          }).then(res => {
            this.$message.success('删除机构管理员成功!')
            this.activeGroupList();
          })
        }).catch(() => {})
      },
      handleSubmit() {
        request({
          url: '/partner-admins/' + this.current.uuid,
          method: 'patch',
          data: {
            type: 'update',
            attributes: this.form
          }
        }).then(res => {
          this.$message.success('更新成功')
          this.activeGroupList()
          this.dialogVisible = false
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  #user-group {
    background-color: #ffffff;

    .header {
      line-height: 55px;
    }

    .main-content {
      overflow-y: auto;
      border: 1px solid #eee;
      border-bottom: none;

      .headimg {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        background-color: #dddddd;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .pager {
      margin-top: 15px;
      margin-bottom: 15px;
    }

    .add-admin {
      width: 700px;

      .el-form {
        width: 600px;
        margin: 10px auto;

        h3 {
          color: #333333;
          text-align: center;
          margin-bottom: 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/TenantAdmin.vue